// extracted by mini-css-extract-plugin
export default {"checkmark":"index__checkmark__Y_DxB"};